import {
  Breadcrumb,
  ErrorAlert,
  modalHandler,
  ModalOpenBtn,
  PageHero,
  PhotoIcon,
  Table,
  useDelete,
  useFetchData,
  useState,
  useTableColumns,
  useToggle,
} from "@";
import Form from "./components/Form";
import { fillForm } from "./utils/helpers";
import { getAdminPopupScreen, toggleActive } from "./utils/api";
import { TableActions, tableColumns } from "./components/TableOptions";

const Index = () => {
  // Breadcrumb links
  const links = [{ name: "النوافذ المنبثقة", link: "" }];
  // State for the item being edited
  const [edit, setEdit] = useState({});

  // Table columns configuration with actions
  const columns = useTableColumns(tableColumns, (row) => (
    <TableActions
      row={row}
      ToggleActive={active}
      handlerEdit={handlerEdit}
      deleteHandler={deleteHandler}
    />
  ));

  // Fetch data from the server
  const { data, setData, isLoading, error, fetchData } = useFetchData({
    noPgn: true,
    fun: getAdminPopupScreen,
  });

  // Handle item deletion
  const { deleteHandler } = useDelete(data, setData, "PopupScreen");

  // Toggle the active state of an item
  const { active } = useToggle(setData, toggleActive, null);

  // Handle item editing
  const handlerEdit = (item) => {
    setEdit(fillForm(item));
    modalHandler();
  };

  return (
    <>
      {/* Error alert */}
      <ErrorAlert reload={fetchData} show={error} />
      {/* Breadcrumb navigation */}
      <Breadcrumb links={links} />

      {/* Form for adding/editing popup ads */}
      <Form data={data} setData={setData} edit={edit} />

      <main className="table-card relative">
        <PageHero
          eyebrow="الموقع / الإعلانات"
          title="النوافذ المنبثقة"
          count={data?.length}
          icon={PhotoIcon}
          hideCount={isLoading}
          headerClassName="flex-row items-center justify-between"
        >
          {/* Button to open modal for adding a new popup ad */}
          <ModalOpenBtn title="اضافة" />
        </PageHero>

        {/* Table displaying popup ads */}
        <Table localPg data={data} columns={columns} isLoading={isLoading} />
      </main>
    </>
  );
};

export default Index;
